import { useMemo } from "react";
import { useParams } from "react-router";

import { tivoAppsApi } from "containers/Request//SRPC/apiClient";
import { RELEASE_STAGE_LABELS, YES_NO_UNKNOWN } from "hooks/tivoApps";

import { TiVoDeviceDetails } from "./components/TiVoDeviceDetails";
import { TEXTS } from "./constants";
import { getOemTabs } from "./utils";

export function TiVoOemDetails() {
  const { platformId, oemId } = useParams();
  const { data, isLoading } = tivoAppsApi.getTiVoOem.useQuery(
    platformId!,
    oemId!,
    {
      queryOptions: {
        enabled: Boolean(oemId) && Boolean(platformId),
      },
    }
  );
  const oem = useMemo(() => data?.results, [data?.results]);

  const fields = [
    {
      label: TEXTS.OEM_NAME_LABEL,
      value: oem?.name,
    },
    {
      label: TEXTS.OEM_ID_LABEL,
      value: oem?.id,
    },
    {
      label: TEXTS.OEM_SLUG_LABEL,
      value: oem?.slug,
    },
    {
      label: TEXTS.OEM_RS_LABEL,
      value: oem?.applicableReleaseStages
        ? oem.applicableReleaseStages
            .map((rs) => RELEASE_STAGE_LABELS[rs])
            .join(", ")
        : "",
    },
    {
      label: TEXTS.OEM_APPROVAL_LABEL,
      value: oem?.publishingConfirmationRequired
        ? YES_NO_UNKNOWN[oem.publishingConfirmationRequired]
        : "",
    },
  ];

  return (
    <TiVoDeviceDetails
      loading={isLoading}
      fields={fields}
      header={TEXTS.OEM_DETAILS_HEADER}
      title={oem?.name || ""}
      tabs={getOemTabs(platformId, oemId)}
      warnings={data?.meta?.warnings}
    />
  );
}
